import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {PhosphorIcon} from "@khanacademy/wonder-blocks-icon";
import {Strut} from "@khanacademy/wonder-blocks-layout";
import {CircularSpinner} from "@khanacademy/wonder-blocks-progress-spinner";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {Body} from "@khanacademy/wonder-blocks-typography";

import correctIcon from "@phosphor-icons/core/bold/check-circle-bold.svg";
import incorrectIcon from "@phosphor-icons/core/bold/x-circle-bold.svg";

type Props = {
    message: string;
    success?: boolean;
    loading?: boolean;
};

class FeedbackMessage extends React.Component<Props> {
    render(): React.ReactNode {
        const {message, success, loading} = this.props;

        let icon;

        if (loading) {
            icon = <CircularSpinner size="xsmall" />;
        } else if (success) {
            icon = <PhosphorIcon color="green" icon={correctIcon} />;
        } else {
            icon = <PhosphorIcon color="red" icon={incorrectIcon} />;
        }

        return (
            <View style={styles.feedbackMessage}>
                {icon}
                <Strut size={spacing.small_12} />
                <Body>{message}</Body>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    feedbackMessage: {
        flexDirection: "row",
        alignItems: "center",
    },
});

export default FeedbackMessage;
